<template>
  <div id="success">
    <div class="success"></div>
    <h5>审核已通过，请前往电脑端付款！</h5>
    <p>
      您已申请成为本协会
      <span>{{applyname}}</span>
      <br>需要您缴纳会费：
      <em>{{payamount}}元</em>
    </p>
    <div class="btn-main btn-home">
      <router-link :to="{path:'/'}">返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      applyname: '',
      payamount: ''
    }
  },
  created() {
    this.getpay()
    this.getname()
  },
  methods: {
    getpay() {
      this.$fetch('/api/OrganizationEnterprise/GetPayAmount').then(result => {
        this.payamount = result
      })
    },
    getname() {
      this.$fetch('/api/OrganizationEnterprise/GetApplyName').then(result => {
        this.applyname = result
      })
    }
  }
}
</script>

<style lang="less" scoped>
#success {
  height: 1334 / @rem-size;
  background: #fff;
}

.success {
  width: 100%;
  height: 437 / @rem-size;
  background: url('../../assets/images/wait.png');
  background-size: 100% 100%;
}

h5 {
  font-size: 36 / @rem-size;
  color: #333;
  margin-top: 24 / @rem-size;
  font-weight: normal;
  text-align: center;
}

p {
  display: block;
  font-size: 28 / @rem-size;
  text-align: center;
  margin-top: 24 / @rem-size;
  padding: 0 24 / @rem-size;
  color: #999;

  span {
    color: #333;
  }

  em {
    font-style: unset;
    color: #ff4f4f;
  }
}

.btn-home {
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  text-align: center;
  line-height: 80 / @rem-size;
  font-size: 36 / @rem-size;
  margin: 0 auto;
  margin-top: 120 / @rem-size;
  border-radius: 8 / @rem-size;

  a {
    color: #fff;
  }
}
</style>
